import { useContext, useCallback } from 'react'
import { type UIGeneralContextType, UIGeneralContext, HidableAPI } from '../contextProviders/uiGeneralContext'

export type UseExclusiveOverlay = {
  <T extends HidableAPI>(hidable: null | T): void
  <T extends HidableAPI>(hidable: null | T, action: (hidable: T) => void): void
}

export const useExclusiveOverlay = (): UseExclusiveOverlay => {
  const context = useContext<UIGeneralContextType>(UIGeneralContext)
  if (null == context) {
    throw new Error('useExclusiveOverlay must be used within a <UIGeneralProvider>')
  }
  const hidable = context.lastHidableRef
  return useCallback<UseExclusiveOverlay>(
    (newHidable, action?) => {
      if (null === newHidable || newHidable !== hidable.current) {
        hidable.current?.hide()
      }
      if (newHidable && 'function' === typeof action) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        action(newHidable)
      }
      hidable.current = newHidable
    },
    [hidable]
  )
}
